import React from "react";
import { Accordion } from "react-bootstrap";

const VisitorFaqDetails = () => {
  // State to track which accordion items are open
  // const [openItems, setOpenItems] = useState({});

  // // Toggle function for accordion items
  // const toggleItem = (index) => {
  //   setOpenItems(prev => ({
  //     ...prev,
  //     [index]: !prev[index]
  //   }));
  // };

  const faqItems = [
    {
      id: "1",
      question: "What is the Visitor Management System?",
      answer: (
        <>
          <p className="w-100 mb-3">
            InOut is a digital platform that simplifies and secures how your
            organization manages visitors on-site. It replaces the paper
            sign-in book with a system that tracks visitor information,
            keeps you compliant with your safety protocols, and gives your
            hosts real-time updates the moment their guest arrives.
          </p>
          <p className="mb-3">
            It's built for anyone visiting your premises — clients, vendors,
            contractors, interview candidates, and personal guests — and is
            designed to be simple enough that a visitor with no prior
            training can check themselves in.
          </p>
        </>
      )
    },
    {
      id: "2",
      question: "What features does the system include?",
      answer: (
        <>
          <p className="w-100 mb-3">
            Key features include:
          </p>
          <ul style={{ lineHeight: "1.5rem" }}>
            <li>Digital visitor registration</li>
            <li>QR code-based check-ins</li>
            <li>Visitor badge printing</li>
            <li>Pre-registration for scheduled appointments</li>
            <li>Real-time visitor tracking and notifications to hosts</li>
            <li>
              Visitor photo capture for enhanced security and seamless
              identification.
            </li>
            <li>
              Multi-language support to help international visitors.
            </li>
          </ul>
        </>
      )
    },
    {
      id: "3",
      question: "What happens after a visitor checks in?",
      answer: (
        <>
          <p className="w-100 mb-3">
            The system automatically notifies the host — the person or
            department the visitor is there to see — typically by email or
            SMS. That notification includes the visitor's name, check-in
            time, and reason for the visit, so the host knows immediately
            that their guest has arrived.
          </p>
          <p className="mb-3">
            The visitor also receives a printed badge, which they wear for
            the duration of their visit so your team can identify them as an
            authorized guest at a glance.
          </p>
        </>
      )
    },
    {
      id: "4",
      question: "Is visitor information stored securely?",
      answer: (
        <>
          <p className="w-100 mb-4">
            Yes. Visitor details are securely stored and used only for
            managing that visit — we don't collect anything beyond what's
            needed, which typically includes:
          </p>
          <ul className="mb-4" style={{ lineHeight: "1.5rem" }}>
            <li>
              The visitor's name and contact details (to identify and
              communicate with them)
            </li>
            <li>The purpose of the visit</li>
            <li>The host's name (to notify them of the arrival)</li>
            <li>ID details or a photo, if required for your security policy</li>
          </ul>
          <p className="w-100 mb-3">
            Visitor data is also deleted after a set retention period rather
            than kept indefinitely.
          </p>
        </>
      )
    },
    {
      id: "5",
      question: "Who has access to visitor information?",
      answer: (
        <>
          <p className="w-100 mb-4">
            Access is limited to your authorized personnel, such as:
          </p>
          <ul className="mb-4" style={{ lineHeight: "1.5rem" }}>
            <li>The host the visitor is there to see</li>
            <li>
              Security staff or receptionists responsible for visitor
              management
            </li>
            <li>System administrators who maintain the platform</li>
          </ul>
          <p className="w-100 mb-3">
            No unauthorized individuals or external parties can access
            visitor data.
          </p>
        </>
      )
    },
    {
      id: "6",
      question: "How do visitors check out?",
      answer: (
        <>
          <p className="w-100 mb-3">
            Visitors can check out from the system using two convenient
            methods:
          </p>
          <ol>
            <li>
              From the Visitor List:
              <ul>
                <li>
                  Authorized personnel can open the list of currently
                  checked-in visitors in the system.
                </li>
                <li>Click the "Check Out" option next to their details.</li>
              </ul>
            </li>
            <li className="mt-3">
              Using the Checkout Option on the Landing Page:
              <ul>
                <li>
                  By Visitor ID: Enter the unique Visitor ID provided during
                  check-in.
                </li>
                <li>
                  By Scanning the QR Code: Use the QR code received during
                  check-in to complete the process quickly and
                  contactlessly.
                </li>
              </ul>
            </li>
          </ol>
        </>
      )
    },
    {
      id: "7",
      question: "Can the system remember frequent visitors?",
      answer: (
        <>
          <p className="w-100 mb-3">
            Yes — the system is designed to make check-ins faster for
            repeat visitors by offering multiple ways to retrieve and
            prefill their information:
          </p>
          <ol>
            <li>
              Past Visitor List on Landing Page:
              <ul>
                <li>
                  The system displays a list of past visitors directly on
                  the landing page.
                </li>
                <li>
                  A returning visitor can select their name from the list,
                  and their details fill in automatically.
                </li>
              </ul>
            </li>
            <li className="mt-3">
              Mobile Number-Based Autofill:
              <ul>
                <li>
                  During check-in, the system prompts for the visitor's
                  mobile number.
                </li>
                <li>
                  If the mobile number is already in the system, their
                  information is fetched and autofilled automatically.
                </li>
              </ul>
            </li>
            <li className="mt-3">
              QR Code Scan:
              <ul>
                <li>
                  On the landing page, visitors can scan their unique QR
                  code received during a previous visit.
                </li>
                <li>
                  The system retrieves the visitor's information and
                  autofills the check-in form instantly.
                </li>
              </ul>
            </li>
          </ol>
          <p>
            These features save time and enhance the user experience,
            ensuring smooth and efficient check-ins for frequent visitors.
          </p>
        </>
      )
    },
    {
      id: "8",
      question: "Is the visitor history updated in real time?",
      answer: (
        <p className="w-100 mb-3">
          Yes, the visitor history is updated in real time. As soon as a
          visitor checks in or out, the system logs their details
          instantly. This ensures that the records are always accurate and
          up-to-date, providing reliable data for security, reporting, and
          operational purposes.
        </p>
      )
    },
    {
      id: "9",
      question: "Is the system available for group visits?",
      answer: (
        <p className="w-100 mb-3">
          Yes. For group visits, the organizer can pre-register the entire
          group in advance, making check-in faster for everyone on arrival.
        </p>
      )
    },
    {
      id: "10",
      question: "Do visitors need to check out when they leave?",
      answer: (
        <p className="w-100 mb-3">
          We recommend it — checking out keeps your visitor records
          accurate and supports your site's safety and evacuation
          procedures, since you'll always know who's currently on-site.
        </p>
      )
    },
    {
      id: "11",
      question: "Who can access the employee list in the management system?",
      answer: (
        <p className="w-100 mb-3">
          Only your authorized personnel with the necessary permissions can
          view the employee list. This keeps sensitive information visible
          only to those who need it for management purposes.
        </p>
      )
    },
    {
      id: "12",
      question: "Who can add a new user to the system?",
      answer: (
        <p className="w-100 mb-3">
          Only your organization's authorized administrators can manage
          user accounts — viewing the user list, adding new users, assigning
          roles based on responsibilities, and removing users when needed.
          This keeps access to the system properly controlled.
        </p>
      )
    },
    {
      id: "13",
      question: "Who has access to download reports?",
      answer: (
        <>
          <p className="w-100 mb-4">
            Only your authorized personnel with report access can download
            them. There are three types of reports available:
          </p>
          <ul className="mb-4" style={{ lineHeight: "1.5rem" }}>
            <li>Visitor Report</li>
            <li>Pre-Registration Report</li>
            <li>Attendance Report</li>
          </ul>
          <p className="w-100 mb-3">
            Authorized users can download reports for specific date ranges
            by selecting the desired "From" and "To" dates, allowing them to
            generate reports for any particular time period.
          </p>
        </>
      )
    }
  ];

  return (
    <>
      
      <div className="">
          {/* <div className="section-padding text-start pb-5">
            <h2 className="title">FAQs</h2>
            <div className="accordion mt-5">
              {faqItems.map((item, index) => (
                <div key={index} className="accordion-item mb-3 border rounded">
                  <div
                    className="accordion-header p-3 d-flex justify-content-between align-items-center cursor-pointer"
                    onClick={() => toggleItem(index)}
                    style={{ cursor: 'pointer' }}
                  >
                    <h5 className="title mb-0">{item.question}</h5>
                    <span className="accordion-icon">
                      {openItems[index] ? <FiMinus/> : <FiPlus />}
                    </span>
                  </div>

                  {openItems[index] && (
                    <div className="accordion-body p-3 border-top">
                      <div className="content">
                        {item.answer}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div> */}
          <div className="container">
          <h2 className="title">FAQs</h2>
          </div>
            <div className="section section-padding-equal bg-color-light faq-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-xl-4">
                {/* <SectionTitle
                  subtitle="Pricing Plan"
                  title="Frequently asked questions"
                  description="Aenean hendrerit laoreet vehicula. Nullam convallis augue at enim gravida pellentesque."
                  textAlignment="heading-left"
                  textColor=""
                /> */}
              </div>
              <div className="col-lg-7 col-xl-8">
                <div className="faq-accordion">
                  <Accordion>
                    {faqItems.map((item) => (
                      <Accordion.Item eventKey={item.id} key={item.id}>
                        <Accordion.Header>
                          <span>{`${item.id}.`}</span>
                          {item.question}
                        </Accordion.Header>
                        <Accordion.Body>
                        {item.answer}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
          <ul className="shape-group-6 list-unstyled">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-7.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-4.png"}
                alt="line"
              />
            </li>
            <li className="shape shape-4 d-none d-lg-block">
              <img
                src={process.env.PUBLIC_URL + "/images/others/poses-lady.png"}
                alt="Poses"
              />
            </li>
          </ul>
        </div>
        </div>
    </>
  );
};

export default VisitorFaqDetails;
